import React, { useEffect, useState } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { useApiHook } from '../Helper/ApiHook/apiHook';
import HADataGrid from '../Common/HADataGrid';
import PatientInfo from './PatientInfo';
import Subscription from './Subscription';
import axios from "axios";
import './Dashboard.css';



function CaseDetail({ selectedCase, refresh }) {
    const { caseidParam } = useParams()
    const navigate = useNavigate();
    const [{ user, stateList }, dispatch] = useStateValue();
    const [caseData, setCaseData] = useState(null);
    const [activeTab, setActiveTab] = useState("patientInfo");
    const url = 'api/ha/getPatientInfo';
    const [caseid, setCaseid] = useState(null);

    
  
    useEffect(() => {
        if (stateList.length == 0) {
            let params = {
                "user_id": user.user_id
            }
            if (user.token !== '' && user.token !== null) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
            }
            axios.post('/api/ha/getHelperData', params)
                .then((response) => {
                    if (response.data.status === 'OK') {
                        dispatch({
                            type: 'ADD_DOCTORLIST',
                            item: response.data.data.doctorList.data
                        });
                        dispatch({
                            type: 'ADD_STATELIST',
                            item: response.data.data.stateList.data
                        });
                        dispatch({
                            type: 'ADD_STATUSLIST',
                            item: response.data.data.statusList.data
                        });
                    } else {
                        alert(response.data.errMsg);
                       
                    }
                })
                .catch((error) => {
                    const errorMsg = error.response?.data?.errMsg || error.message;
                    alert(errorMsg);
                  
                });
        }

    }, []);

 
   
    useEffect(() => {
        if (typeof selectedCase !== 'undefined') {

            setCaseid(selectedCase.id);
         
        }
        else {
            setCaseid(caseidParam);
           
        }
    }, [selectedCase])

    const params = {
        "case_id": caseid,
        "user_id": user.user_id
    }

    const [{ status, loading, data, error }, callAPI] = useApiHook(url,
        {
            verb: "post",
            useCache: false,
            token: user.token,
            params: params
        });

    useEffect(() => {
        if (caseid !== null) {
            callAPI();
        }
       
    }, [caseid])

    useEffect(() => {

        if (status === 'fetched') {

            if (data.status === "OK") {

                if (data.data.length > 0) {
                    setCaseData(data.data[0]);
                    console.log(data.data[0]);
                }
                else {
                    setCaseData(null);

                }
            }

        }
        else if (status === 'error') {
            console.log(data);
            alert(error);

        }
    }, [status])

    const config_refill = {
        title: '',
        historyFlag: false,
        selectMultiple: false,
        primaryKey: 'id',
        maxKey: '',
        serverName: 'default',
        databaseName: 'herpalert',
        tableName: 'refill_cases',
        selectSql: `select 
        CONVERT_TZ(c.created_at, 'UTC', 'America/Los_Angeles') as 'created_at',
        'case' as caseType,
        c.id as 'id',
        null as 'refillID',
        c.dose_spot_patient_id,
        c.token,
        c.status,
        c.dose_spot_status,
        u.display_name as DrName,
        c.pharmacy_id,
        c.city as 'pharmacy_city',
        s.name as 'pharmacy_state',
        c.zip as 'pharmacy_zip',
        c.transaction_id,
        c.paid,
        u.dose_spot_user_id
        from cases c
        left join doctor_notes n on n.case_id = c.id
        left join states s on s.id = c.state_id 
        left join users u on u.id = c.dermatologist_id 
        where c.id = ${caseid}

        union

        SELECT
        CONVERT_TZ(rc.created_at, 'UTC','America/Los_Angeles') as 'created_at',
        'refill' as caseType,
        c.id as 'id',
        rc.id as 'refillID',
        rc.dose_spot_patient_id,
        rc.token,
        rc.status,
        rc.dose_spot_status,
        u.display_name as DrName,
        rc.pharmacy_id,
        '' as 'pharmacy_city',
        s.name as 'pharmacy_state',
        rc.zip as 'pharmacy_zip',
        rc.transaction_id,
        rc.paid_amount,
        u.dose_spot_user_id
        FROM refill_cases rc
        inner join cases c on c.id = rc.case_id
        left join states s on s.id = rc.state_id
        left join users u on u.id = rc.dermatologist_id
        where  rc.case_id = ${caseid}
        order by created_at desc
        `,
        joinTables: true,
        nonVisiableCols: ['pharmacy_state_id', 'dose_spot_user_id'],
        nonEditAbleCols: ['id'],
        defaultValues: [],
        readOnlyCols: [],
        colSize: {
            created_at: '80px', 'id': '70px', casetype: '50px', refillID: '70px', dose_spot_patient_id: '80px', pharmacy_id: '70px', token: '80px', status: '85px',
            DrName: '150px', pharmacy_city: '100px', pharmacy_state: '50px', pharmacy_zip: '80px', skip_photo: '40px', dose_spot_status: '70px', transaction_id: '80px',
            paid: '80px'
        },
        displayNames: {
            id: 'Case', refillID: 'Refill', casetype: 'Type', dose_spot_patient_id: 'DoseSpot', skip_photo: 'Call', dose_spot_status: 'Rx Status',
            pharmacy_state: 'State', pharmacy_zip: 'Zip', pharmacy_city: 'City', created_at: 'Date', member_id: 'Member', pharmacy_id: 'Pharmacy'
        },
        dropdownCols: [],
        links: {
            'pharmacy_id': { url: '/Pharmacy', params: ['casetype', 'token', 'id', 'refillID', 'pharmacy_id'] },
            'dose_spot_patient_id': { url: '/DoseSpot', params: ['casetype', 'token', 'id', 'refillID', 'dose_spot_patient_id', 'pharmacy_id', 'dose_spot_user_id'] }
        },
        toolbar: false,
        showExport: false,
        bulkActionName: '',
        allowNew: false,
        allowEdit: false,
        allowDelete: false,
        allowExpand: false
    }
    const config_delivery = {
        title: '',
        historyFlag: false,
        selectMultiple: false,
        primaryKey: 'id',
        maxKey: '',
        serverName: 'default',
        databaseName: 'herpalert',
        tableName: 'honeybee_fulfillment',
        selectSql: `SELECT 
                    a.id,
                    b.order_id, b.member_id, a.patient_id, a.orderNo, a.prescription_id, a.fulfillment_no, a.delivery_date, a.current_status,
                    a.streetAddress, a.city, a.state, a.zip,
                    a.is_delivered, a.tracking_id, b.remaining_refills, a.message, a.updated
                    FROM herpalert.honeybee_fulfillment a
                    INNER JOIN herpalert.honeybee_orders b ON b.order_id = a.order_id
                    WHERE b.case_id = ${caseid}
                    ORDER BY a.updated DESC`,
        joinTables: true,
        nonVisiableCols: ['id'],
        nonEditAbleCols: [],
        defaultValues: [],
        readOnlyCols: [],
        colSize: {
            order_id: '80px', member_id: '80px', patient_id: '80px', orderNo: '90px', prescription_id: '100px', fulfillment_no: '80px',
            delivery_date: '120px', current_status: '150px', streetAddress: '200px', city: '90px', state: '60px', zip: '70px',
            is_delivered: '90px', tracking_id: '100px', remaining_refills: '100px',  updated: '140px'
        },
        displayNames: {
            order_id: 'Order ID', member_id: 'Member', patient_id: 'Patient', orderNo: 'Order #', prescription_id: 'Rx ID', fulfillment_no: 'Fill #',
            delivery_date: 'Delivery', current_status: 'Status', streetAddress: 'Address', city: 'City', state: 'State', zip: 'Zip',
            is_delivered: 'Delivered', tracking_id: 'Tracking', remaining_refills: 'Refills left', message: 'Message', updated: 'Updated'
        },
        dropdownCols: [],
        links: {},
        toolbar: false,
        showExport: false,
        bulkActionName: '',
        allowNew: false,
        allowEdit: false,
        allowDelete: false,
        allowExpand: false
    }

   
    const callDoseSpot = () => {
        const url = 'api/doseSpot/getDoseSpotToken';

        const params = {

            "nuid": user.NUID
        }

        var endpoint = location.origin + '/' + url;
        axios.post(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.data.status === "OK") {

                    console.log('');

                }

            })
            .catch(function (response) {
                //handle error
                alert(response);
                console.log(response);
            });
    }
    const callBraintree = () => {
        var subscriptionId ='2v229v'
        const url = `api/braintree/subscription/${subscriptionId}`;

        const params = {

            "subscriptionId": '	2v229v'
        }

        var endpoint = location.origin + '/' + url;
        axios.get(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.statusText === "OK") {

                    console.log('');

                }

            })
            .catch(function (response) {
                //handle error
                alert(response);
                console.log(response);
            });
    }
    
    return (
        <div className="dashboard tab" >
            {
               
                caseData &&
                <div className="display-6 mt-2">
                        <span className="fs-2"> {caseData.first_name} {caseData.middle_initial} {caseData.last_name} - {caseData.State} </span> <span className="ml-4 fs-4">Email: {caseData.email}</span>
                </div>
            }
                      
            <br />
            <div className=''>
                {/*<TabView>*/}
                {/*    <TabPanel header="Patient Info">*/}
                {/*        {caseData && <PatientInfo initialData={caseData} />}*/}

                {/*    </TabPanel>*/}
                {/*    <TabPanel header="Case & Refills">*/}
                {/*        <IDWDataGrid config={config_refill} />*/}
                {/*    </TabPanel>*/}
                {/*        {caseData && caseData.DeliveryType !== null ?*/}
                {/*    <TabPanel header="Mail Orders">*/}
                {/*        <IDWDataGrid config={config_delivery} />*/}
                {/*    </TabPanel>*/}
                {/*: null}*/}
                
                    
                       
                        
                {/*</TabView>*/}

                {/* Tab Navigation */}
                <ul className="nav nav-pills">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "patientInfo" ? "active" : ""}`}
                            onClick={() => setActiveTab("patientInfo")}
                        >
                            Patient Info
                        </button>
                    </li>

                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "caseRefills" ? "active" : ""}`}
                            onClick={() => setActiveTab("caseRefills")}
                        >
                            Case & Refills
                        </button>
                    </li>

                
                    {caseData && caseData.member_id !== null && (
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "subscription" ? "active" : ""}`}
                                onClick={() => setActiveTab("subscription")}
                            >
                                Subscription
                            </button>
                        </li>
                    )}
                    {caseData && caseData.Subs_id === 7 && (
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "mailOrders" ? "active" : ""}`}
                                onClick={() => setActiveTab("mailOrders")}
                            >
                                Mail Orders
                            </button>
                        </li>
                    )}
                </ul>

                {/* Tab Content */}
                <div className="tab-content mt-3">
                    <div className={`tab-pane fade ${activeTab === "patientInfo" ? "show active" : ""}`}>
                        {caseData && <PatientInfo initialData={caseData} refresh={callAPI} />}
                    </div>

                    <div className={`tab-pane fade ${activeTab === "caseRefills" ? "show active" : ""}`}>
                        {caseid && <HADataGrid config={config_refill} />}
                    </div>
                  
                   
                    {caseData && caseData.member_id !== null && (
                        <div className={`tab-pane fade ${activeTab === "subscription" ? "show active" : ""}`}>
                            {caseData && <Subscription initialData={caseData} refresh={callAPI} />}
                        </div>
                    )}
                    {caseData && caseData.Subs_id === 7 && (
                        <div className={`tab-pane fade ${activeTab === "mailOrders" ? "show active" : ""}`}>
                            {caseid && <HADataGrid config={config_delivery} />}
                        </div>
                    )}
                </div>

             
            </div>




        </div>

    );

}
export default CaseDetail;